"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshSymbolTradeInfo = exports.SymbolTradeInfoPublishManager = exports.DEFAULT_TRADE_INFO = exports.DEFAULT_LEVERAGE_V2_INNER = exports.DEFAULT_LEVERAGE_V2 = void 0;
const rxjs_1 = require("rxjs");
const interface_1 = require("../../../interface");
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const trade_utils_lib_1 = require("trade_utils_lib");
const accountWebSocket_1 = require("../../../utils/accountWebSocket");
const const_1 = require("../../../component/const");
const isMulti_1 = require("./isMulti");
// 默认杠杆倍数5
exports.DEFAULT_LEVERAGE_V2 = 5;
exports.DEFAULT_LEVERAGE_V2_INNER = exports.DEFAULT_LEVERAGE_V2 + "";
exports.DEFAULT_TRADE_INFO = {
    leverage: exports.DEFAULT_LEVERAGE_V2_INNER,
    isolated_mode: interface_1.FutureMarginType.CROSS,
    isMulti: false,
    isDefault: true,
};
const FetchSymbolTradeInfo = (symbol) => {
    if (!symbol) {
        return (0, rxjs_1.throwError)("FetchSymbolTradeInfo: symbol cannot be null");
    }
    return (0, trade_utils_lib_1.requestWithRetry)(() => {
        return (0, FutureAPI_1.querySymbolFuturesTradeInfo)(const_1.FutureAccountType, symbol);
    }, { name: "querySymbolFuturesTradeInfo" });
};
function symbolTradeInfoFactory(symbol) {
    const triggerSubject = new rxjs_1.Subject();
    // 照顾web，每一小时轮询一次
    const refreshOffset = 1000 * 60 * 60;
    const observable = (0, rxjs_1.merge)((0, accountWebSocket_1.getIsolatedModeChangeWsObservable)(), // 仓位模式wss消息变更
    (0, accountWebSocket_1.getLeverageChangeWsObservable)(), // 杠杆倍数wss消息变更
    (0, rxjs_1.timer)(0, refreshOffset), // 1小时轮询触发事件
    triggerSubject);
    let cache = null;
    const publisher = observable.pipe((0, operators_1.filter)((res) => {
        // wss推送 或者 通知
        if (typeof res === "object") {
            if (res.symbol !== symbol) {
                return false;
            }
            let isChanged = false;
            if ("isolated_mode" in res) {
                if (res.isolated_mode !== (cache === null || cache === void 0 ? void 0 : cache.isolated_mode)) {
                    isChanged = true;
                }
            }
            if ("leverage" in res) {
                if (res.leverage !== (cache === null || cache === void 0 ? void 0 : cache.leverage)) {
                    isChanged = true;
                }
            }
            if ("isMulti" in res) {
                if (res.isMulti !== (cache === null || cache === void 0 ? void 0 : cache.isMulti)) {
                    isChanged = true;
                }
            }
            return isChanged;
        }
        return true;
    }), (0, operators_1.switchMap)((res) => {
        return (0, rxjs_1.combineLatest)([(0, isMulti_1.getMultiSymbolObserve)().pipe((0, operators_1.map)((set) => set.has(symbol))), FetchSymbolTradeInfo(symbol)]).pipe((0, operators_1.map)(([isMulti, res]) => {
            return Object.assign(Object.assign({}, res), { isMulti, error: undefined });
        }), (0, operators_1.tap)((res) => {
            cache = Object.assign(cache !== null && cache !== void 0 ? cache : {}, res);
        }), (0, operators_1.catchError)((error) => {
            return (0, rxjs_1.of)(Object.assign(Object.assign({}, exports.DEFAULT_TRADE_INFO), { error }));
        }));
    }), (0, operators_1.publishBehavior)(exports.DEFAULT_TRADE_INFO), (0, operators_1.refCount)());
    const refreshSymbolTradeInfo = (value) => {
        triggerSubject.next(value);
    };
    return {
        publisher,
        refreshSymbolTradeInfo,
    };
}
function symbolTradeInfoPublishManager() {
    const publisherMap = new Map();
    function getInstance(symbol) {
        if (!publisherMap.has(symbol)) {
            publisherMap.set(symbol, symbolTradeInfoFactory(symbol));
        }
        return publisherMap.get(symbol);
    }
    function getPublish(symbol) {
        return getInstance(symbol).publisher;
    }
    function refreshSymbolTradeInfo(symbol, value) {
        getInstance(symbol).refreshSymbolTradeInfo(value);
    }
    return {
        getPublish,
        refreshSymbolTradeInfo,
    };
}
exports.SymbolTradeInfoPublishManager = symbolTradeInfoPublishManager();
function refreshSymbolTradeInfo(value) {
    exports.SymbolTradeInfoPublishManager.refreshSymbolTradeInfo(value.symbol, value);
}
exports.refreshSymbolTradeInfo = refreshSymbolTradeInfo;
